// extracted by mini-css-extract-plugin
module.exports = {"titleUnderline":"styles__titleUnderline___sBDM_","titleUnderlineSpan":"styles__titleUnderlineSpan___1P-6F"};